import { memo } from "react";
import PublicIcon from '@mui/icons-material/Public';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const MarketingWebsiteAndSupportLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.HighRiskMerchant].MarketingWebsiteAndSupport}`}
        Icon={PublicIcon}
        {...props}
    >
        Marketing Website and Support
    </StepLabel>
);

export default memo(MarketingWebsiteAndSupportLabel);
